import { Stack } from '@axo/ui-core/components/layout/item';
import { ReactNode } from 'react';
import { useFormContext } from 'react-hook-form';
import { useAxoFormContext } from '../../context/AxoForm/AxoForm';
import { useOnValueChange } from '../../utils/useOnValueChange';

interface Props<StepData> {
  onChange: (data: StepData) => void;
  onSubmit: (data: StepData) => Promise<void>;
  touchedFieldsOverride?: string[];
  children: ReactNode;
}

export const Form = <StepData extends Record<string, unknown>>({
  onSubmit,
  onChange,
  touchedFieldsOverride,
  children,
}: Props<StepData>) => {
  const { watch, formState, handleSubmit } = useFormContext<StepData>();
  const { formRef } = useAxoFormContext();

  useOnValueChange<StepData>({
    onChange,
    watch,
    formState,
    touchedFieldsOverride,
  });

  return (
    <form
      onSubmit={handleSubmit(onSubmit)}
      id="axo-form"
      data-testid="axo-form"
      ref={formRef}
    >
      <Stack gap="4xs">{children}</Stack>
    </form>
  );
};
